import React from 'react';
import { Link } from 'react-router-dom';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { FooterContainer, FooterContent, QuickLinks, ContactInfo, SocialLinks, BottomBar } from './styles/Footer.Styles';

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <QuickLinks>
          <h3>Quick Links</h3>
          <ul>
            <li><Link to="/">Home</Link></li>
            <li><Link to="/about">About Us</Link></li>
            <li><Link to="/rosters">Rosters</Link></li>
            <li><Link to="/fixtures">Fixtures</Link></li>
            <li><Link to="/results">Results</Link></li>
            <li><Link to="/player-stats">Player Stats</Link></li>
          </ul>
        </QuickLinks>
        
        <ContactInfo>
          <h3>Contact Us</h3>
          <ul>
            <li>TBC</li>
          </ul>
        </ContactInfo>
        
        <SocialLinks>
          <h3>Follow Us</h3>
          <div className="social-icons">
            <a href="https://www.instagram.com/nomadsihc/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
              <FontAwesomeIcon icon={faInstagram} />
            </a>
          </div>
        </SocialLinks>
      </FooterContent>
      
      <BottomBar>
        <p>&copy; {new Date().getFullYear()} Nomads Ice Hockey Club. All rights reserved.</p>
      </BottomBar>
    </FooterContainer>
  );
};

export default Footer; 